<div class="kcs-card">
	<!-- Header: indietro + titolo a sinistra, azioni a destra -->
	<div class="d-flex justify-content-between align-items-center mb-3">
		<div class="d-flex flex-row align-items-center">
			<button title="Torna indietro" class="goBackButton" (click)="goBack()">
				<i class="pi pi-arrow-left" aria-hidden="true"></i>
			</button>
			<h5 class="titolo-card mb-0">{{ 'appointment.home.title' | translate }}</h5>
		</div>
		<div class="d-flex gap-2">
			<p-button label="Imposta slot" size="small" icon="pi pi-clock" severity="secondary" [outlined]="true" (onClick)="OpenImpostaSlot()"></p-button>
		</div>
	</div>

	<p-divider />

	<full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>

<app-evento-appuntamento [date]="appuntamento" [tipo_utenza]="tipo_utenza" [cmp_id]="cmp_id" [visible]="visible" (visibleChange)="isVisible($event)"></app-evento-appuntamento>

<ng-template #modalCompanyCalendar>
	<div>
		<h6 class="mb-2">Disponibilità Appuntamenti</h6>

		<div class="row">
			<div class="col-12 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Giorni Disponibili</label>
				<p-multiselect [options]="days" placeholder="Seleziona giorni" [(ngModel)]="calendario_obj.giorni_settimana" [style]="{ width: '100%' }"></p-multiselect>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-md-6 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Mattina Inizio</label>
				<p-datepicker [(ngModel)]="calendario_obj.mattina_inizio" (ngModelChange)="setTimeOutMorningStart($event)" [timeOnly]="true" hourFormat="24" placeholder="Ora Inizio" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>
			<div class="col-12 col-md-6 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Mattina Fine</label>
				<p-datepicker [(ngModel)]="calendario_obj.mattina_fine" (ngModelChange)="setTimeOutMorningEnd($event)" [timeOnly]="true" hourFormat="24" placeholder="Ora Fine" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-md-6 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Pomeriggio Inizio</label>
				<p-datepicker [(ngModel)]="calendario_obj.pomeriggio_inizio" (ngModelChange)="setTimeOutAfternoonStart($event)" [timeOnly]="true" hourFormat="24" placeholder="Ora Inizio" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>
			<div class="col-12 col-md-6 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Pomeriggio Fine</label>
				<p-datepicker [(ngModel)]="calendario_obj.pomeriggio_fine" (ngModelChange)="setTimeOutAfternoonEnd($event)" [timeOnly]="true" hourFormat="24" placeholder="Ora Fine" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>
		</div>

		<p-divider />

		<h6 class="mb-2">Giorni da Oscurare</h6>

		<div class="row align-items-end">
			<div class="col-12 col-md-5 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">Da</label>
				<p-datepicker [(ngModel)]="date_da_obj" [showTime]="false" dateFormat="dd/mm/yy" placeholder="Data Inizio" [ngModelOptions]="{ standalone: true }" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>

			<div class="col-12 col-md-5 flex flex-col gap-1 mb-3">
				<label class="kcs-form-label">A</label>
				<p-datepicker [(ngModel)]="date_a_obj" [showTime]="false" dateFormat="dd/mm/yy" placeholder="Data Fine" [ngModelOptions]="{ standalone: true }" appendTo="body" [style]="{ width: '100%' }"></p-datepicker>
			</div>

			<div class="col-12 col-md-2 flex flex-col gap-1 mb-3">
				<p-button size="small" icon="pi pi-plus" severity="success" [outlined]="true" (onClick)="aggiungiIntervalloOscurato()" ariaLabel="Aggiungi intervallo"></p-button>
			</div>
		</div>

		@if (intervalliOscurati.length > 0) {
			<div class="d-flex flex-col gap-2">
				@for (intervallo of intervalliOscurati; track intervallo; let i = $index) {
					<div class="d-flex align-items-center justify-content-between gap-2 p-2" style="border: 1px solid var(--kcs-surface-border); border-radius: 8px;">
						<span class="kcs-form-label mb-0"> <strong>Dal:</strong> {{ intervallo.da | date: 'dd/MM/yyyy' }} &nbsp; <strong>Al:</strong> {{ intervallo.a | date: 'dd/MM/yyyy' }} </span>
						<p-button size="small" icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" (onClick)="rimuoviIntervallo(i)" ariaLabel="Rimuovi intervallo"></p-button>
					</div>
				}
			</div>
		}
	</div>
</ng-template>
